var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "time" }, [
    _vm.timer
      ? _c("button", {
          class: _vm.countdown === null ? "icon-play" : "icon-pause",
          attrs: { type: "button" },
          on: { click: _vm.timerToggle },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("h4", [_vm._v(_vm._s(_vm.t("cookbook", _vm.label)))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.displayTime))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }